"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTO_SWAP_LIMITS = exports.ALLOWED_AUTO_SWAP_PAIRS = void 0;
const enums_1 = require("../enums");
exports.ALLOWED_AUTO_SWAP_PAIRS = [enums_1.ExchangeRateName.OKLP_USDT];
exports.AUTO_SWAP_LIMITS = {
    [enums_1.ExchangeRateName.OKLP_USDT]: {
        threshold: { max: 1000 },
        purchase: { max: 10000 },
    },
};
//# sourceMappingURL=auto-swap.js.map